const sendStartEvent = () => {
    console.log("start");
    // @ts-ignore
    window.ga("send", {
        hitType: "event",
        eventCategory: "Diagnosis",
        eventAction: "start",
    });
};

const sendCompleteEvent = () => {
    // @ts-ignore
    window.ga("send", {
        hitType: "event",
        eventCategory: "Diagnosis",
        eventAction: "complete",
    });
};

const sendAnswerEvent = (answeredQuestionNo: number) => {
    // @ts-ignore
    window.ga("send", {
        hitType: "event",
        eventCategory: "Diagnosis",
        eventAction: "answer",
        eventLabel: ("00" + answeredQuestionNo).slice(-2),
    });
};

export { sendStartEvent, sendCompleteEvent, sendAnswerEvent };
